import axios from 'axios';
import { logoutAndRedirect } from '../utils/authRedirect';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authLisualToken'); // Actualizado
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      logoutAndRedirect();
    }
    return Promise.reject(error);
  }
);

export default api;
